var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedBackPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38333 4.16666H4.85L5.4 1.51666C5.46667 1.20833 5.36667 0.891663 5.15 0.666663C4.78333 0.299996 4.19167 0.299996 3.83333 0.666663L0.5 4C0.175 4.30833 0 4.73333 0 5.175V10C0 10.9167 0.75 11.6667 1.66667 11.6667H6.6C7.26667 11.6667 7.86667 11.2667 8.13333 10.6583L9.91667 6.49166C10.3833 5.39166 9.575 4.16666 8.38333 4.16666ZM18.3333 8.33333H13.4C12.7333 8.33333 12.1333 8.73333 11.8667 9.34166L10.0833 13.5083C9.61667 14.6083 10.4167 15.8333 11.6167 15.8333H15.15L14.6 18.4833C14.5333 18.7917 14.6333 19.1083 14.85 19.3333C15.2167 19.7 15.8083 19.7 16.1667 19.3333L19.5 16C19.8167 15.6833 19.9917 15.2667 19.9917 14.825V10C20 9.08333 19.25 8.33333 18.3333 8.33333Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedBackPrimary);
export default __webpack_public_path__ + "static/media/feedBackPrimary.1b713c38.svg";
export { ForwardRef as ReactComponent };